export default __webpack_public_path__ + "static/media/G0245.Mental_Capacity.1658482860000.9384dbeb.jpg";